import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import ScrollToTop from "components/ScrollToTop/ScrollToTop";


import indexRoutes from "routes/index.jsx";

import { units } from "config/UnitsConfig.jsx";
import { Context } from "Context.jsx";

// import * as ExcelJs from 'exceljs/dist/exceljs.min.js';

//import ReactGA from 'react-ga';

var history = createBrowserHistory();

// const unlisten = history.listen((location, action) => {
//   console.log(action, location.pathname, location.state);
// })


class App extends Component {
  constructor(props) {
    super(props);

    this.setUnit = this.setUnit.bind(this);

    this.state = {
      unit: units.ha, //default
      setUnit: this.setUnit
    }

    //ReactGA.initialize('UA-000000-01', { debug: true });
  }

  setUnit(unit) {
    this.setState({
      unit: unit
    })
  }

  render() {
    // console.log('App: render');
    return (
      <Context.Provider value={this.state}>
        <Router history={history}>
          <ScrollToTop>
            <Switch>
              {indexRoutes.map((prop, key) => {
                return <Route path={prop.path} key={key} component={prop.component} />;
              })}
            </Switch>
          </ScrollToTop>
        </Router>
      </Context.Provider>
    );
  }
}

export default App;